module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCond.d28887e.woff";